export const VietnamBanks = [
  "Vietcombank",
  "VietinBank",
  "BIDV",
  "Agribank",
  "Techcombank",
  "MB Bank",
  "VPBank",
  "ACB",
  "Sacombank",
  "TPBank",
  "VIB",
  "SHB",
  "HDBank",
  "LienVietPostBank",
  "MSB",
  "Eximbank",
  "OceanBank",
  "SeABank",
  "Bac A Bank",
  "Nam A Bank",
  "NCB",
  "SCB",
  "DongA Bank",
  "PVcomBank",
  "SaiGonBank",
  "VietABank",
  "ABBANK",
  "BaoViet Bank",
  "KienLongBank",
  "VietCapital Bank",
  "PG Bank",
  "CIMB Bank",
  "UOB Bank",
  "Shinhan Bank",
  "Standard Chartered",
  "Hong Leong Bank",
  "Public Bank",
  "Indovina Bank",
  "HSBC",
  "CitiBank",
  "ANZ Bank",
  "Woori Bank",
  "IBK Bank",
  "KB Kookmin Bank",
  "KEB Hana Bank",
  "Kasikorn Bank",
  "Bangkok Bank",
  "Maybank",
  "DBS Bank",
  "Deutsche Bank",
] as const;
